export default "__VITE_ASSET__DKu7JRAH__"